import SurveyResponsePage from '../pages/survey/SurveyResponsePage.vue'

const routes = [
    {
        name: 'SurveyResponsePage',
        path: '/survey-response',
        component: SurveyResponsePage,
        metha: {
            requiresAuth: false
        }   
    }
]

export default routes